import { Navigate } from "react-router";
import { useClientAuth } from "../../utils/useAuth";

const ClientPublicRoute = ({ children }) => {
  const { isClient } = useClientAuth();

  if (isClient) {
    return <Navigate to={"/client/dashboard"} replace />;
  }
  return children;
};

export default ClientPublicRoute;
